// utils/buildProductInfo.ts
export const buildProductInfo = (product: any) => [
  { label: 'Brand', value: product.product_brand },
  { label: 'Day / Night', value: product?.dayOrNight?.name },
  { label: 'Strength (CBD:THC)', value: product?.product_strength },
  { label: 'Category', value: product?.product_strength },
  { label: 'Formulation', value: product?.productFormulation?.name },
  { label: 'TGA', value: product?.tgaCategory?.short_name },
];
